module.exports = __webpack_public_path__ + "img/six-crimson-cranes.8f5bb66f.png";